var React = require('react');

function Remove (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"5.5","y":"11","width":"14","height":"3","rx":".5","fill":"currentColor","fillRule":"evenodd"}));
}

Remove.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = Remove;

Remove.default = Remove;
